<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>
         <!-- 控制按钮 -->
     <!-- <button style="position: absolute; height: 3vh;width: 4vw;  top: 27vh;z-index: 999;" @click="toggleZIndex" class="control-btn">banner</button> -->
       <!--  -->
            <!-- banner -->
            <img v-if="isonhow" :src="imageUrlone" alt="" class="imgoneru" >


            <div>

          
             
            <!-- 地图容器 -->
         <div id="map"></div>


            </div>
      
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
    // import Bottom2 from "@/view/public/heardpc.vue";
    // import Header2 from '../public/newheaderx.vue'
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    // 在组件中导入 Leaflet
        import L from 'leaflet';
        import 'leaflet/dist/leaflet.css';  // 导入样式
        import axios from 'axios';
import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下

    export default {
        computed: {
           // 从 Vuex 的 state 中获取 isEnglish 数据
           ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
          
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return {
                // 天地图服务的密钥
                tk: 'bcdfd077a80733b5d581fce12fc92dc7',
                map: null,
                cities: [
                    { name: '贵州', lat:26.563152 , lon: 105.035520,companyen:'暂无',  company: '贵州铭恒新材料有限公司',  qualificationen: '暂无' ,qualification: '旗舰工厂' ,addressen:'暂无',address: '贵州省六盘水市水城经济开发区铝产业园',phone:'020-39390239-312',email:'moc@mingheng-group.com', imgurl:'http://192.168.0.69/dev-api/profile/upload/2024/10/22/pic-GUIZHOU%20factory1_20241022111501A009.jpg',link:'https://www.mingheng-group.com/'},
                    { name: '广州', lat: 23.1291, lon: 113.2644,companyen:'暂无', company: '广州谱祺商业发展有限公司',qualificationen: '暂无' ,qualification: '谱祺品牌运营主体' ,addressen:'暂无', address: '广州市南沙自贸区海滨路169号122单元',phone:'86/20/3939 0239',email:'coop@puki.vip', imgurl:'http://192.168.0.69/dev-api/profile/upload/2024/10/22/pic-PUKI%20exhibition%20center2_20241022104847A005.jpg',link:'http://192.168.0.69:8080/#/exhibitioncenter'},

                ],
                isScrolled: false,//导航栏是否收缩
                imageUrlone: require('../../assets/pic-service.png'),
                bannerZIndex: 1,  // 默认 banner 的 z-index
                isonhow:false
            };
        },
        computed: {
             // 从 Vuex 的 state 中获取 isEnglish 数据
             ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
             
        },
        mounted() {
            
            // 修复默认图标路径
            delete L.Icon.Default.prototype._getIconUrl;  // 删除默认图标路径

            // 设置新的图标路径
            L.Icon.Default.mergeOptions({
            iconUrl: require('leaflet/dist/images/marker-icon.png'),  // 普通图标
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),  // 高清图标
            shadowUrl: require('leaflet/dist/images/marker-shadow.png')  // 阴影图标
            });


               	// 初始化地图，将视图设置为中国的中心（经纬度：35.8617, 104.1954），并设置适当的缩放级别
			this.map = L.map('map').setView([35.8617, 104.1954], 4); // 中心设置为中国的中心，缩放级别为5
            this.fetchData();
                // 添加天地图的底图
                this.addTileLayer();
              

                // 添加城市标记
                // this.addCityMarkers();

            this.initObserver(); // 初始化观察器
             window.addEventListener('wheel', this.initObserver, { passive: false });
        },
        beforeDestroy() {
            window.removeEventListener("wheel", this.initObserver);
            window.removeEventListener("scroll", this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
          
        },
        watch: {
            // 监听 isEnglish 变化
            isEnglish(newVal) {
            // 清除当前的标记
            this.clearMarkers();
            // 重新添加标记
            this.addCityMarkers();
            },
         },
        methods: {


            async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/salesnetwork`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    // this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;
                    //天地图
                    this.tk=data[0].tk;
                    
                    this.cities=[];
                this.cities = data.map(city => ({
                    name: city.name,
                    lat: city.lat,
                    lon: city.lon,
                    company: city.company,
                    companyen: city.companyen,
                    qualification: city.qualification,
                    qualificationen: city.qualificationen,
                    address: city.address,
                    addressen: city.addressen,
                    phone: city.phone,
                    email: city.email,
                    imgurl: `${apiUrls.baseUrl}${city.imgurl}`, // 动态拼接图片的完整路径
                    link: city.link,
                })) .sort((a, b) => {
                        // 如果 `company` 为目标值，将其排在最后
                        if (a.company === "广州谱祺商业发展有限公司") return 1;
                        if (b.company === "广州谱祺商业发展有限公司") return -1;
                        return 0; // 其他顺序保持不变
                    });
                    
                this.addCityMarkers();
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        },

            // 切换 z-index，使其强制显示在最上层
            // toggleZIndex() {
            //     // 切换 banner 的 z-index
            //    this.isonhow=true;
            //    this.isScrolled=true
            // },
            // ____________________________________________地图开始__________________________________
                    // 清除所有标记
                    clearMarkers() {
                    this.map.eachLayer((layer) => {
                        if (layer instanceof L.Marker) {
                        this.map.removeLayer(layer);
                        }
                    });
                    },
        
            // 添加天地图底图
                addTileLayer() {
               // 矢量底图
			const vecLayer = L.tileLayer(
					`http://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.tk}`,
					{
						maxZoom: 18,
						minZoom: 1,
						tileSize: 256,
						zoomOffset: 0,
						attribution: '&copy; 天地图 矢量底图',
					}
			);

			// 影像底图
			const imgLayer = L.tileLayer(
					`http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.tk}`,
					{
						maxZoom: 18,
						minZoom: 1,
						tileSize: 256,
						zoomOffset: 0,
						attribution: '&copy; 天地图 卫星底图',
					}
			);

			// 地形底图
			const terLayer = L.tileLayer(
					`http://t0.tianditu.gov.cn/ter_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ter&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${this.tk}`,
					{
						maxZoom: 18,
						minZoom: 1,
						tileSize: 256,
						zoomOffset: 0,
						attribution: '&copy; 天地图 地形底图',
					}
			);

      // 默认加载矢量底图
      imgLayer.addTo(this.map);

      // 图层控制
      L.control.layers({
        '矢量': vecLayer,
        '卫星': imgLayer,
        '地形': terLayer,
      }).addTo(this.map);
    },
            // 添加城市标记
            addCityMarkers() {
            this.cities.forEach((city) => {// 使用箭头函数，确保 this 是当前 Vue 实例
                // console.log(this.isEnglish)
                let popupContent = ` <div style="font-size: 13px;max-width: 800vw; word-wrap: break-word; white-space: normal;">
                <b >${this.isEnglish ? city.companyen :city.company}</b><br><br>
                 `;

                // 判断是否有公司信息，若有则显示
                if (city.qualification) {
                popupContent += `${this.isEnglish ? 'qualificationen：'+city.qualificationen : '资质：'+city.qualification}<br>`;
                }

                // 判断是否有权限信息，若有则显示
                if (city.address) {
                    popupContent += `${this.isEnglish ? 'address：'+city.addressen :'地址：'+city.address}<br>`;
                }

                   // 判断是否有电话信息，若有则显示
                   if (city.phone) {
                    popupContent += `${this.isEnglish ? 'phone：'+city.phone :'电话：'+city.phone}<br>`;
                }
                  // 判断是否邮箱限信息，若有则显示
                  if (city.phone) {
                    popupContent += `${this.isEnglish ? 'email：'+city.email :'邮箱：'+city.email}<br>`;
                }
               
                  // 判断是否有图片信息，若有则添加图片
                if (city.imgurl) {
                    popupContent += `<img src="${city.imgurl}" alt="City Image" style="width: 13vw; height: auto; margin-top: 5px;">`;
                }

                 // 添加一个跳转链接
                popupContent += `
                    <a href="${city.link || '#'}" style="display: inline-block; color: #007BFF; text-decoration: none; margin-top: 10px; font-weight: bold;" target="_blank">
                        > ${this.isEnglish ? 'more' :'了解更多'}
                    </a>
                `;

                popupContent += `</div>`; // 关闭容器 div

                // 添加标记并绑定弹出框
                L.marker([city.lat, city.lon])
                .addTo(this.map)
                .bindPopup(popupContent)
                .openPopup();
            });
            },

            // ____________________________________________地图结束__________________________________
            initObserver() {
              
                // const options = {
                //     root: this.$refs.boddy,
                //     rootMargin: '0px',
                //     threshold: 0.1 // 10% 进入视口时触发
                // };
                // const ss=   options.root.scrollTop;
                const ss = this.$refs.boddy.scrollTop;  // 获取滚动位置
                this.isScrolled = ss > 0;  // 通过条件判断设置 isScrolled
                // if(ss!=0){
                //     this.isScrolled = true;
                // }else{ this.isScrolled=false;}


            },


           
           
            
        }
    }
</script>
<style scoped>
/* ?地图样式开始 */
Header{
    z-index: 999;
}
/* 地图样式：让地图位于固定区域 */
#map {
  width: 100%;
  height: calc(100vh - 100px); /* 使地图占据剩余空间，假设头部高度为 100px */
  position: relative; /* 保证地图定位不受影响 */
  z-index: 1;
}
/* 样式 */
#mapContainer {
  width: 100%;
  height: 500px;

}

.map-selector {
  margin-top: 20px;
 
}

.map-selector button {
  padding: 10px;
  margin-right: 10px;
  background-color: #007BFF;
  color: white;
  border: none;
  cursor: pointer;
}

.map-selector button:hover {
  background-color: #0056b3;
}

/* 地图样式结束 */

.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}

/*整体布局开始*/
.boddy {
height: 100vh;


overflow-y: auto; /* 允许垂直滑动 */
z-index: 999;
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: block;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
